import { render, staticRenderFns } from "./infoDetail.vue?vue&type=template&id=810c5902&scoped=true"
import script from "./infoDetail.vue?vue&type=script&lang=js"
export * from "./infoDetail.vue?vue&type=script&lang=js"
import style0 from "./infoDetail.vue?vue&type=style&index=0&id=810c5902&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810c5902",
  null
  
)

export default component.exports